<template>
  <div>
    <v-container fluid>
      <v-simple-table>
        <thead>
          <tr>
            <th>Subject, Teacher</th>
            <th>Credit</th>
            <th v-for="gp in grading_periods" :key="gp.id">{{ gp.name }}</th>
            <th>Year Average</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="section in averages" :key="section.id">
            <td>{{ section.name }}</td>
            <td>{{ Number(section.credit).toFixed(2) }}</td>
            <td v-for="gp in grading_periods" :key="gp.id">
              <v-btn
                fab
                dark
                small
                :color="getAverage(section, gp).color"
                @click="getCourseGradeBook(section, gp)"
                >{{ getAverage(section, gp).avg }}</v-btn
              >
            </td>
            <td>{{ courseResult(section) }}</td>
          </tr>
          <tr>
            <td></td>
            <td>{{ totalCredits }}</td>
            <td v-for="gp in grading_periods" :key="gp.id">
              {{ quarterResult(gp) }}
            </td>
            <td>
              <v-btn fab dark :color="getColor(gpa)">{{ gpa }}</v-btn> GPA
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-card class="mt-5" flat tile v-if="section.name">
        <v-toolbar dark color="secondary">
          <v-toolbar-title>{{ section.name }}</v-toolbar-title>
        </v-toolbar>
        <student-gradebook-table :scores="scores" :average="average + ''">
        </student-gradebook-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import StudentGradebookTable from "./StudentGradebookTable.vue";

export default {
  components: { StudentGradebookTable },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    averages: [],
    scores: [],
    grading_periods: [],
    average: "",
    section: {},
  }),
  watch: {
    student: ["getGradeBook"],
  },
  computed: {
    totalCredits() {
      return (Math.round(10 * this.averages
        .map((a) => Number(a.credit))
        .reduce((c, t) => (t += c), 0)) / 10).toFixed(2);
    },
    gpa() {
      let credits = 0;
      let points = 0;
      this.averages.forEach((section) => {
        let res = this.courseResult(section);
        if (res != "N/A") {
          credits += Number(section.credit);
          points += res * Number(section.credit);
        }
      });
      return credits > 0 ? Math.round((10 * points) / credits) / 10 : "N/A";
    },
  },
  methods: {
    quarterResult(gp) {
      let credits = 0;
      let points = 0;
      this.averages.forEach((a) => {
        let avg = a.avgs.find((av) => av.grading_period_id == gp.id).avg;
        if (avg != "N/A") {
          credits += Number(a.credit);
          points += avg * Number(a.credit);
        }
      });
      return credits > 0 ? Math.round((10 * points) / credits) / 10 : "N/A";
    },
    courseResult(section) {
      let credits = 0;
      let points = 0;
      section.avgs.forEach((a) => {
        if (a.avg != "N/A") {
          credits += 1;
          points += a.avg;
        }
      });
      return credits > 0 ? Math.round((10 * points) / credits) / 10 : "N/A";
    },
    getColor(average) {
      let a = Number(average);
      if (a < 65) {
        return "red";
      }
      if (65 <= a && a <= 74) {
        return "orange";
      }
      if (75 <= a && a <= 84) {
        return "yellow";
      }
      if (85 <= a && a <= 94) {
        return "green";
      }
      if (a > 94) {
        return "purple";
      }
      return "grey";
    },
    getAverage(section, gp) {
      let ind = section.avgs.findIndex((a) => a.grading_period_id == gp.id);
      if (ind < 0) {
        return { avg: "", color: "grey" };
      }
      let av = section.avgs[ind];
      let avg = av.circle50 ? "(" + av.avg + ")" : av.avg;
      return {
        avg: avg,
        color: this.getColor(av.avg),
      };
    },
    getGradeBook() {
      this.averages = [];
    let uri = this.student.user_id
      ? `my-schedule/students-gradebook/${this.student.user_id}`
      : "my-schedule/self-gradebook";
    this.$sisApi("get", uri)
        .then((response) => {
          this.averages = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGradingPeriods() {
      this.grading_periods = [];
      this.$sisApi("get", `my-schedule/grading-periods`)
        .then((response) => {
          this.grading_periods = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCourseGradeBook(section, gp) {
      this.section = section;
      let uri = this.student.user_id
        ? `my-schedule/students-course-gradebook/${this.student.user_id}/${section.id}`
        : `my-schedule/self-course-gradebook/${section.id}`;
      this.$sisApi("get", uri, {
        start_date: gp.start_date.substr(0, 10),
        end_date: gp.end_date.substr(0, 10),
      })
        .then((response) => {
          this.scores = response.data.filter((s) => s.id > 0);
          this.average = response.data.find((s) => s.id == 0).avg;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getGradingPeriods()
    this.getGradeBook()
  }
};
</script>
